import React, { useState } from "react";
import styled from "styled-components";
import { FaEdit } from "react-icons/fa";
import { DataHora } from "./DadosRodada";
import api from "../api";
import ModalLoginCartola from "./ModalLoginCartola";

const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  min-width: 280px;
`;

export const Thead = styled.thead`
  background-color: #1a5276;
  color: white;
`;
export const Tbody = styled.tbody``;
export const Tr = styled.tr`
  border-bottom: 1px solid #f0f0f0;
  &:last-child { border-bottom: none; }
`;

export const Th = styled.th`
  text-align: start;
  padding: 10px 12px;
  font-size: 13px;
  font-weight: 600;
  @media (max-width: 500px) {
    ${(props) => props.onlyWeb && "display: none"}
  }
`;

export const Td = styled.td`
  padding: 10px 12px;
  text-align: ${(props) => (props.alignCenter ? "center" : "start")};
  font-size: 14px;
  @media (max-width: 500px) {
    ${(props) => props.onlyWeb && "display: none"}
    padding: 8px 8px;
  }
`;

const Escudo = styled.img`
  width: 32px;
  height: 32px;
  object-fit: contain;
  border-radius: 4px;
`;

const BtnVincular = styled.span`
  cursor: pointer;
  font-size: 18px;
  user-select: none;
  &:hover { opacity: 0.7; }
`;

const GridTimes = ({ users, setUsers, setOnEdit }) => {
  const [modalCartola, setModalCartola] = useState(false);
  const [timeSelecionado, setTimeSelecionado] = useState(null);

  const handleEdit = (item) => {
    setOnEdit(item);
  };

  const handleVincular = (item) => {
    setTimeSelecionado(item);
    setModalCartola(true);
  };

  const handleRefresh = async () => {
    try {
      const res = await api.get("liga/listarTimes");
      setUsers(res.data);
    } catch (e) {}
  };

  return (
    <>
      <TableWrapper>
        <Table>
          <Thead>
            <Tr>
              <Th style={{ width: 40 }}></Th>
              <Th>Nome</Th>
              <Th onlyWeb>Cartoleiro</Th>
              <Th>Usuário</Th>
              <Th style={{ textAlign: "center" }}>Cartola</Th>
              <Th style={{ textAlign: "center" }}>[]</Th>
            </Tr>
          </Thead>
          <Tbody>
            {users.map((item, i) => (
              <Tr key={i}>
                <Td>
                  {item.escudo ? (
                    <Escudo src={item.escudo} alt={item.nome} onError={(e) => { e.target.style.display = "none"; }} />
                  ) : (
                    <span style={{ fontSize: 24 }}>⚽</span>
                  )}
                </Td>
                <Td>{item.nome}</Td>
                <Td onlyWeb>{item.idCartola}</Td>
                <Td>{item.nomeUsuario}</Td>
                <Td alignCenter>
                  {item.temGlbId
                    ? <span title="Conta Cartola vinculada">🔗</span>
                    : <BtnVincular title="Vincular conta Cartola" onClick={() => handleVincular(item)}>➕</BtnVincular>
                  }
                </Td>
                <Td alignCenter>
                  <FaEdit style={{ cursor: "pointer", color: "#666" }} onClick={() => handleEdit(item)} />
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableWrapper>

      {modalCartola && timeSelecionado && (
        <ModalLoginCartola
          idTime={timeSelecionado.id}
          nomeTime={timeSelecionado.nome}
          onClose={() => setModalCartola(false)}
          onSuccess={handleRefresh}
        />
      )}
    </>
  );
};

export default GridTimes;

